import React, { useEffect, useState } from "react";

import DocumentsFiles from "./DocumentsFiles";
import AssetsFiles from "./AssetsFiles";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getKeyFromText } from "../../../utils/Utilities";
import { useSelector } from "react-redux";
import {
  updateAuditTrails,
  updateStatusQuoAuditTrails,
} from "../../../services/auditTrails";
import { uploadedDocumentsAuditsNames } from "../../../constants/constants";
import { useParams } from "react-router-dom";

const UploadedDocs = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [tabNo, setTabNo] = useState(1);
  const updates = useSelector((state) =>
    state.auditTrail.updates
      .filter(
        (item) =>
          item.objectName.toLowerCase() ===
            uploadedDocumentsAuditsNames[0].toLowerCase() ||
          item.objectName.toLowerCase() ===
            uploadedDocumentsAuditsNames[1].toLowerCase()
      )
      .map((item) => item?.auditTrailId)
  );
  const documentsUpdates = useSelector(
    (state) => state.statusQuoDocuments.updates.statusQuoMedia
  );
  const handleUpdates = async (data) => {
    try {
      const result = await updateAuditTrails(data, id);
    } catch (e) {
      console.log(e);
    }
  };
  const handleUpdatesDocumentsTrails = async () => {
    const result = await updateStatusQuoAuditTrails(
      documentsUpdates.map((item) => item.auditTrailId),
      id
    );
  };
  useEffect(() => {
    if (updates?.length) {
      handleUpdates(updates);
    }
  }, [updates]);
  useEffect(() => {
    if (documentsUpdates?.length) {
      try {
        handleUpdatesDocumentsTrails();
      } catch (e) {
        console.log(e);
      }
    }
  }, [documentsUpdates]);

  return (
    <Box>
      <Box
        sx={{
          color: "color.magentaLight2",
          borderBottom: "2px solid transperant",
          display: "flex",
          paddingInline: "40px",
        }}
      >
        <Typography
          sx={{
            color: `${tabNo === 1 ? "#957BA0" : "black"}`,

            borderBottom: `${tabNo === 1 ? "4px solid #957BA0" : "none"}`,
            cursor: "pointer",
            padding: "5px 18px",
          }}
          onClick={() => setTabNo(1)}
        >
          {t(getKeyFromText("Assets"))}
        </Typography>
        <Typography
          sx={{
            color: `${tabNo === 2 ? "#957BA0" : "black"}`,
            borderBottom: `${tabNo === 2 ? "4px solid #957BA0" : "none"}`,

            padding: "5px 18px",

            cursor: "pointer",
          }}
          onClick={() => {
            setTabNo(2);
          }}
        >
          {t(getKeyFromText("Documents"))}
        </Typography>
      </Box>
      {tabNo === 1 ? <AssetsFiles /> : <DocumentsFiles />}
    </Box>
  );
};

export default UploadedDocs;
